import AsyncTaskQueue from "@/lib/queue/async-queue";

export const parametersMapLayersQueue = new AsyncTaskQueue<HTMLImageElement>({
  concurrencyLimit: 32,
});
